import React, { useEffect, useState } from "react";
// primeReact
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
// context
import { useContextSimulator } from "../../SimulatorContext";

import { addMonths, differenceInMonths, format, parseISO } from "date-fns";
const CashPayment = () => {
  const {
    oneTimePayTerms,
    calculateInterestFreeTotalOrderPrice,
    setTotalOrderPrice,
    firstOneTimePayDate,
    setFirstOneTimePayDate,
    othersOneTimePayDate,
    setOthersOneTimePayDate,
    selectedOneTimePayTerm, setSelectedOneTimePayTerm,
    oneTimeParcelValue, totalOrderPrice,
    oneTimeInstallments, setOneTimeInstallments
  } = useContextSimulator();

  const generateObject = (installmentValue, installmentTerms, parcelDateOne, parcelDateTwo) => {
    const installmentsArray = [];
    const firstDate = new Date(parcelDateOne);
    const secondDate = parcelDateTwo ? new Date(parcelDateTwo) : null;

    for (let i = 0; i < installmentTerms; i++) {
      let dueDate;

      if (i === 0) {
        dueDate = firstDate;
      } else if (i === 1 && parcelDateTwo) {
        dueDate = secondDate;
      } else if (i > 1 && secondDate) {
        dueDate = addMonths(parcelDateTwo, i - 1);
      } else {
        dueDate = addMonths(firstDate, i);
      }
      const formattedDueDate = format(new Date(dueDate), "yyyy-MM-dd");

      const installmentObject = {
        value: parseFloat(installmentValue),
        due_date: formattedDueDate,
        sequence_number: `${i + 1}/${installmentTerms}`,
        want_choose: 0, // 0 para a primeira parcela, 1 para as demais
      };

      installmentsArray.push(installmentObject);
    }

    return installmentsArray;
  };

  useEffect(() => {
    calculateInterestFreeTotalOrderPrice(
      1,
      setSelectedOneTimePayTerm,
      oneTimePayTerms,
      setTotalOrderPrice
    )
  }, []);

  useEffect(() => {
    // console.log("oneTimePayTerms: ", oneTimePayTerms);
    // console.log("firstOneTimePayDate: ", firstOneTimePayDate);
    // console.log("othersOneTimePayDate: ", othersOneTimePayDate);
    // console.log("selectedOneTimePayTerm: ", selectedOneTimePayTerm);
    // console.log("oneTimeParcelValue: ", parseFloat(totalOrderPrice / selectedOneTimePayTerm));
    let test = generateObject(parseFloat(totalOrderPrice / selectedOneTimePayTerm), selectedOneTimePayTerm, firstOneTimePayDate, othersOneTimePayDate);

    // if (firstOneTimePayDate && othersOneTimePayDate) {
    //   test = generateObject(parseFloat(totalOrderPrice / selectedOneTimePayTerm), selectedOneTimePayTerm, firstOneTimePayDate, othersOneTimePayDate);
    // } else {
    //   test = generateObject(parseFloat(totalOrderPrice / selectedOneTimePayTerm), selectedOneTimePayTerm, firstOneTimePayDate, othersOneTimePayDate);
    // }
    // console.log("test: ", test);
    
    setOneTimeInstallments(test);
  }, [oneTimePayTerms, firstOneTimePayDate, othersOneTimePayDate, oneTimeParcelValue])

  return (
    <div className="row">
      <div className="col-xl-3 col-md-6">
        <label className="mb-3">Parcelas</label>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: 18,
            border: "1px solid #ced4da",
            borderRadius: 8,
            margin: 0,
            justifyContent: "space-between",
          }}
        >
          <Dropdown
            value={selectedOneTimePayTerm}
            onChange={(e) =>
              calculateInterestFreeTotalOrderPrice(
                e.value,
                setSelectedOneTimePayTerm,
                oneTimePayTerms,
                setTotalOrderPrice
              )
            }
            options={oneTimePayTerms}
            optionLabel="label"
            placeholder="Selecione"
            className="border-0 bg-none px-0 w-100"
          />
        </div>
      </div>
      <div className="col-xl-3 col-md-6">
        <label className="mb-3">Data Primeira Parcela</label>
        <Calendar
          value={firstOneTimePayDate}
          onChange={(e) => setFirstOneTimePayDate(e.value)}
          dateFormat={"dd/mm/yy"}
          mask="99/99/9999"
          className="w-100"
          locale="pt"
          // minDate={new Date()}
        />
      </div>
      {selectedOneTimePayTerm > 1 && (
        <div className="col-md-3">
          <label className="mb-3">Data Parcelamentos</label>
          <Calendar
            value={othersOneTimePayDate}
            onChange={(e) => setOthersOneTimePayDate(e.value)}
            dateFormat={"dd/mm/yy"}
            mask="99/99/9999"
            className="w-100"
            locale="pt"
            // minDate={new Date()}
          />
        </div>
      )}
    </div>
  );
};

export default CashPayment;
